import { useState } from "react";
import { Copy, Check } from "lucide-react";

// PATCH 37 Mi9 — one copy-to-clipboard pattern with a consistent "Copied" confirmation (1.6s).
export default function CopyButton({ value, label = "Copy", testid = "copy-button", className = "k-btn k-btn-ghost", style }) {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(String(value ?? "")); }
    catch {
      const ta = document.createElement("textarea"); ta.value = String(value ?? "");
      document.body.appendChild(ta); ta.select(); try { document.execCommand("copy"); } catch { /* ignore */ } ta.remove();
    }
    setDone(true); setTimeout(() => setDone(false), 1600);
  };
  return (
    <button type="button" className={className} data-testid={testid} onClick={copy}
      aria-live="polite" style={{ padding: "6px 12px", fontSize: 13, ...style }}>
      {done ? <><Check size={13} aria-hidden="true" /> Copied</> : <><Copy size={13} aria-hidden="true" /> {label}</>}
    </button>
  );
}
